module.exports = __webpack_public_path__ + "static/img/Government Public Service.8eb75cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/Government Public Service.jpg
// module id = g9U/
// module chunks = 1